import { render, staticRenderFns } from "./resultDetail.vue?vue&type=template&id=6796a806&scoped=true&"
import script from "./resultDetail.vue?vue&type=script&lang=js&"
export * from "./resultDetail.vue?vue&type=script&lang=js&"
import style0 from "./resultDetail.vue?vue&type=style&index=0&id=6796a806&lang=scss&scoped=true&"
import style1 from "./resultDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796a806",
  null
  
)

export default component.exports